// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__LCzQZ","language-button":"LoginPage_language-button__iWkJl","header":"LoginPage_header__q5Jic","content":"LoginPage_content__pwMIW"};